import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

import MissingRecordModal from "./MissingRecordModal";
import BeefProductPicker from "./BeefProductPicker";
import GatewayExistsAlert from "./GatewayExistsAlert";
import GatewayRequestDebugPanel from "./GatewayRequestDebugPanel";
import MissingRetailerField from "./MissingRetailerField";
import { buildGatewayAdminRecordUrl } from "../../../services/missingReports";

const ProductOverridesMissingSelectedModal = ({
  selected,
  taskRun,
  actionLoading,
  error,
  loadingTaskRun,
  onClose,
  onResolve,
  onSkip,
  onReject,
  resolveDisabled,
  skipDisabled,
  retailerId,
  retailerName,
  retailerMode,
  onRetailerModeChange,
  onRetailerNameChange,
  onRetailerIdChange,
  suggestedRetailerId,
  suggestedRetailerName,
  retailerResolutionSource,
  hasRetailerRefId,
  exactRetailerMatchFound,
  beefProductId,
  onBeefProductChange,
  overrideName,
  onOverrideNameChange,
  gatewayOverrideStatus,
  resolveRequestPreview,
}) => (
  <MissingRecordModal
    open={Boolean(selected)}
    title="Product override missing record"
    record={selected}
    taskRun={taskRun}
    actionLoading={actionLoading}
    error={error}
    onClose={onClose}
    onResolve={onResolve}
    onSkip={onSkip}
    onReject={onReject}
    resolveDisabled={resolveDisabled}
    skipDisabled={skipDisabled}
  >
    <Box>
      <GatewayExistsAlert
        checking={Boolean(gatewayOverrideStatus?.checking)}
        exists={Boolean(gatewayOverrideStatus?.exists)}
        url={
          gatewayOverrideStatus?.id
            ? buildGatewayAdminRecordUrl("beef_product_overrides", gatewayOverrideStatus.id)
            : ""
        }
        label="override"
      />
      {loadingTaskRun ? (
        <Typography variant="body2" color="text.secondary">
          Loading record details...
        </Typography>
      ) : null}
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {selected?.override_name || "Unnamed override"}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Normalized: {selected?.normalized_product_name || "Not provided"}
      </Typography>
      <Table size="small" sx={{ mt: 2, border: "1px solid #e0e0e0" }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: "30%", fontWeight: 600 }}>Field</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Retailer</TableCell>
            <TableCell>
              <MissingRetailerField
                retailerLabel={selected?.retailer}
                retailerId={retailerId}
                retailerMode={retailerMode}
                onRetailerModeChange={onRetailerModeChange}
                retailerName={retailerName}
                onRetailerNameChange={onRetailerNameChange}
                onRetailerIdChange={onRetailerIdChange}
                suggestedRetailerId={suggestedRetailerId}
                suggestedRetailerName={suggestedRetailerName}
                retailerResolutionSource={retailerResolutionSource}
                hasRetailerRefId={hasRetailerRefId}
                exactRetailerMatchFound={exactRetailerMatchFound}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Beef product</TableCell>
            <TableCell>
              <BeefProductPicker
                selectedId={beefProductId}
                onSelectedIdChange={onBeefProductChange}
                seedTerms={[selected?.override_name, selected?.normalized_product_name]}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Override name</TableCell>
            <TableCell>
              <TextField
                size="small"
                fullWidth
                label="Override name"
                value={overrideName}
                onChange={(event) => onOverrideNameChange(event.target.value)}
                helperText="Saved as the en-US override display name."
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <GatewayRequestDebugPanel
        title="Gateway debug request preview (Beef Overrides Missing)"
        request={resolveRequestPreview}
      />
    </Box>
  </MissingRecordModal>
);

export default ProductOverridesMissingSelectedModal;
